import {AvailableCars, BookingProcess} from './views';

export default [
    {
        name: "available-cars",
        path: "/available-cars",
        get component(){
            return AvailableCars;
        }
    },
    {
        name: "booking",
        path: "/booking",
        get component(){
            return BookingProcess;
        }
    }
];